import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// A wooden signpost — a post with one or two pointing planks.
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/signpost.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ box, seed }) => {
    const wood = shade(0xb08543, (rand(seed) - 0.5) * 0.15);
    box(0, 0.85, 0, 0.14, 1.7, 0.14, shade(wood, -0.1));        // post
    const dir = rand(seed + 1) > 0.5 ? 1 : -1;
    box(dir * 0.45, 1.4, 0, 0.8, 0.32, 0.06, wood);            // upper plank
    if (rand(seed + 2) > 0.4) {
      box(-dir * 0.45, 1.0, 0, 0.7, 0.3, 0.06, shade(wood, -0.05)); // lower plank
    }
  };

export default build;
